<template>
	<div id="section-categorias-destaque" class="container-fluid">
		<div>
			<VueSlickCarousel v-bind="settings">
				<div v-for="(categoria, index) in sliders" :key="index">
					<section class="item flex flex-col items-center justify-center container-categoria">
						<a
							class="flex flex-col items-center justify-center hover"
							:href="`https://www.dpcnet.com.br/catalogo?categoria=${categoria.link}`"
							target="_blank"
						>
							<section class="item-item">
								<img
									:src="
										categoria.tamanhos[0].nome_img ||
										'https://img.dpcnet.com.br/catalogo/imagem_indisponivel.png'
									"
									class="img-responsive"
								/>
							</section>
							<label class="mt-4 text-dpc-green desc-categoria">{{
								categoria.titulo || 'Sem descrição'
							}}</label>
						</a>
					</section>
				</div>
			</VueSlickCarousel>
		</div>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
	name: 'CategoriasSlider',
	components: {
		VueSlickCarousel,
	},
	props: {
		sliders: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			categorias: [
				{
					id: 17,
					categoriapai_id: null,
					descricao: 'Alimento',
					nivel: 1,
					status: 1,
					integracao_id: '29',
					filhos: [
						{
							id: 193,
							categoriapai_id: 17,
							descricao: 'Adoçante',
							nivel: 2,
							status: 1,
							integracao_id: '1213',
							filhos: [
								{
									id: 738,
									categoriapai_id: 193,
									descricao: 'ACHOCOLATADO',
									nivel: 3,
									status: 1,
									integracao_id: '1215',
								},
								{
									id: 622,
									categoriapai_id: 193,
									descricao: 'ADOÇANTE',
									nivel: 3,
									status: 1,
									integracao_id: '1217',
								},
							],
							codigo: '1213',
						},
						{
							id: 95,
							categoriapai_id: 17,
							descricao: 'Bebida',
							nivel: 2,
							status: 1,
							integracao_id: '1202',
							filhos: [
								{
									id: 567,
									categoriapai_id: 95,
									descricao: 'BEBIDA LACTEA',
									nivel: 3,
									status: 1,
									integracao_id: '1386',
								},
							],
							codigo: '1202',
						},
						{
							id: 289,
							categoriapai_id: 17,
							descricao: 'Cereal',
							nivel: 2,
							status: 1,
							integracao_id: '54',
							filhos: [
								{
									id: 727,
									categoriapai_id: 289,
									descricao: 'BARRA CEREAL',
									nivel: 3,
									status: 1,
									integracao_id: '982',
								},
							],
							codigo: '54',
						},
						{
							id: 212,
							categoriapai_id: 17,
							descricao: 'Foods',
							nivel: 2,
							status: 1,
							integracao_id: '1373',
							codigo: '1373',
						},
						{
							id: 241,
							categoriapai_id: 17,
							descricao: 'Fórmula',
							nivel: 2,
							status: 1,
							integracao_id: '1099',
							filhos: [
								{
									id: 662,
									categoriapai_id: 241,
									descricao: 'FÓRMULA',
									nivel: 3,
									status: 1,
									integracao_id: '1100',
								},
							],
							codigo: '1099',
						},
					],
					codigo: '29',
				},
				{
					id: 942,
					categoriapai_id: null,
					descricao: 'Beleza',
					nivel: 1,
					status: 1,
					integracao_id: '1462',
					filhos: [
						{
							id: 950,
							categoriapai_id: 942,
							descricao: 'Capilar',
							nivel: 2,
							status: 1,
							integracao_id: '1501',
							filhos: [
								{
									id: 963,
									categoriapai_id: 950,
									descricao: 'ACESSÓRIOS',
									nivel: 3,
									status: 1,
									integracao_id: '1516',
									filhos: [
										{
											id: 984,
											categoriapai_id: 963,
											descricao: 'BIGODIM',
											nivel: 4,
											status: 1,
											integracao_id: '1517',
										},
										{
											id: 972,
											categoriapai_id: 963,
											descricao: 'BOB',
											nivel: 4,
											status: 1,
											integracao_id: '1518',
										},
										{
											id: 979,
											categoriapai_id: 963,
											descricao: 'CAPA',
											nivel: 4,
											status: 1,
											integracao_id: '1519',
										},
										{
											id: 991,
											categoriapai_id: 963,
											descricao: 'CLIPS',
											nivel: 4,
											status: 1,
											integracao_id: '1520',
										},
										{
											id: 994,
											categoriapai_id: 963,
											descricao: 'ELÁSTICO',
											nivel: 4,
											status: 1,
											integracao_id: '1521',
										},
										{
											id: 980,
											categoriapai_id: 963,
											descricao: 'ESCOVA',
											nivel: 4,
											status: 1,
											integracao_id: '1555',
										},
										{
											id: 986,
											categoriapai_id: 963,
											descricao: 'GOLA HIGIÊNICA',
											nivel: 4,
											status: 1,
											integracao_id: '1523',
										},
										{
											id: 969,
											categoriapai_id: 963,
											descricao: 'GRAMPO',
											nivel: 4,
											status: 1,
											integracao_id: '1560',
										},
										{
											id: 990,
											categoriapai_id: 963,
											descricao: 'MÁSCARA',
											nivel: 4,
											status: 1,
											integracao_id: '1563',
										},
										{
											id: 981,
											categoriapai_id: 963,
											descricao: 'PENTE',
											nivel: 4,
											status: 1,
											integracao_id: '1569',
										},
										{
											id: 987,
											categoriapai_id: 963,
											descricao: 'PINCEL',
											nivel: 4,
											status: 1,
											integracao_id: '1530',
										},
										{
											id: 970,
											categoriapai_id: 963,
											descricao: 'PIRANHA',
											nivel: 4,
											status: 1,
											integracao_id: '1525',
										},
										{
											id: 973,
											categoriapai_id: 963,
											descricao: 'PROTETOR DE ORELHA',
											nivel: 4,
											status: 1,
											integracao_id: '1526',
										},
										{
											id: 978,
											categoriapai_id: 963,
											descricao: 'PULVERIZADOR',
											nivel: 4,
											status: 1,
											integracao_id: '1527',
										},
										{
											id: 992,
											categoriapai_id: 963,
											descricao: 'TIGELA',
											nivel: 4,
											status: 1,
											integracao_id: '1528',
										},
										{
											id: 974,
											categoriapai_id: 963,
											descricao: 'TOUCA',
											nivel: 4,
											status: 1,
											integracao_id: '1529',
										},
									],
								},
								{
									id: 960,
									categoriapai_id: 950,
									descricao: 'ALISANTE',
									nivel: 3,
									status: 1,
									integracao_id: '1503',
									filhos: [
										{
											id: 993,
											categoriapai_id: 960,
											descricao: 'GEL',
											nivel: 4,
											status: 1,
											integracao_id: '1535',
										},
										{
											id: 988,
											categoriapai_id: 960,
											descricao: 'RELAXAMENTO',
											nivel: 4,
											status: 1,
											integracao_id: '1536',
										},
									],
								},
								{
									id: 967,
									categoriapai_id: 950,
									descricao: 'CREME DE TRATAMENTO',
									nivel: 3,
									status: 1,
									integracao_id: '1546',
									filhos: [
										{
											id: 977,
											categoriapai_id: 967,
											descricao: 'CREME DE TRATAMENTO',
											nivel: 4,
											status: 1,
											integracao_id: '1548',
										},
									],
								},
							],
							codigo: '1501',
						},
						{
							id: 953,
							categoriapai_id: 942,
							descricao: 'Depilatório',
							nivel: 2,
							status: 1,
							integracao_id: '1469',
							filhos: [
								{
									id: 968,
									categoriapai_id: 953,
									descricao: 'LÂMINA',
									nivel: 3,
									status: 1,
									integracao_id: '1593',
								},
								{
									id: 964,
									categoriapai_id: 953,
									descricao: 'ROLL ON',
									nivel: 3,
									status: 1,
									integracao_id: '1596',
								},
							],
							codigo: '1469',
						},
						{
							id: 947,
							categoriapai_id: 942,
							descricao: 'Maquiagem',
							nivel: 2,
							status: 1,
							integracao_id: '1651',
							filhos: [
								{
									id: 965,
									categoriapai_id: 947,
									descricao: 'APONTADOR',
									nivel: 3,
									status: 1,
									integracao_id: '1683',
								},
								{
									id: 962,
									categoriapai_id: 947,
									descricao: 'CURVADOR DE CÍLIOS',
									nivel: 3,
									status: 1,
									integracao_id: '1685',
								},
							],
							codigo: '1651',
						},
						{
							id: 956,
							categoriapai_id: 942,
							descricao: 'Unhas',
							nivel: 2,
							status: 1,
							integracao_id: '1468',
							filhos: [
								{
									id: 959,
									categoriapai_id: 956,
									descricao: 'ACESSÓRIOS',
									nivel: 3,
									status: 1,
									integracao_id: '1597',
									filhos: [
										{
											id: 982,
											categoriapai_id: 959,
											descricao: 'AMOLECEDOR DE CUTÍCULAS',
											nivel: 4,
											status: 1,
											integracao_id: '1613',
										},
									],
								},
								{
									id: 966,
									categoriapai_id: 956,
									descricao: 'CERA NUTRITIVA',
									nivel: 3,
									status: 1,
									integracao_id: '1615',
									filhos: [
										{
											id: 975,
											categoriapai_id: 966,
											descricao: 'CERA NUTRITIVA',
											nivel: 4,
											status: 1,
											integracao_id: '1617',
										},
									],
								},
								{
									id: 961,
									categoriapai_id: 956,
									descricao: 'CUTELARIA',
									nivel: 3,
									status: 1,
									integracao_id: '1471',
									filhos: [
										{
											id: 976,
											categoriapai_id: 961,
											descricao: 'ALICATE PARA CUTÍCULAS',
											nivel: 4,
											status: 1,
											integracao_id: '1619',
										},
										{
											id: 983,
											categoriapai_id: 961,
											descricao: 'CORTADOR',
											nivel: 4,
											status: 1,
											integracao_id: '1620',
										},
										{
											id: 995,
											categoriapai_id: 961,
											descricao: 'ESPÁTULA',
											nivel: 4,
											status: 1,
											integracao_id: '1621',
										},
										{
											id: 971,
											categoriapai_id: 961,
											descricao: 'TESOURA',
											nivel: 4,
											status: 1,
											integracao_id: '1623',
										},
									],
								},
							],
							codigo: '1468',
						},
					],
					codigo: '1462',
				},
				{
					id: 9,
					categoriapai_id: null,
					descricao: 'Farmacêutico',
					nivel: 1,
					status: 1,
					integracao_id: '261',
					codigo: '261',
				},
				{
					id: 936,
					categoriapai_id: null,
					descricao: 'Fralda',
					nivel: 1,
					status: 1,
					integracao_id: '1444',
					filhos: [
						{
							id: 937,
							categoriapai_id: 936,
							descricao: 'Geriátrica',
							nivel: 2,
							status: 1,
							integracao_id: '1449',
							codigo: '1449',
						},
						{
							id: 938,
							categoriapai_id: 936,
							descricao: 'Infantil',
							nivel: 2,
							status: 1,
							integracao_id: '1448',
							codigo: '1448',
						},
						{
							id: 939,
							categoriapai_id: 936,
							descricao: 'Tecido',
							nivel: 2,
							status: 1,
							integracao_id: '1450',
							codigo: '1450',
						},
					],
					codigo: '1444',
				},
				{
					id: 19,
					categoriapai_id: null,
					descricao: 'Higiene oral',
					nivel: 1,
					status: 1,
					integracao_id: '1078',
					filhos: [
						{
							id: 62,
							categoriapai_id: 19,
							descricao: 'Adesivo para dentadura',
							nivel: 2,
							status: 1,
							integracao_id: '1079',
							codigo: '1079',
						},
						{
							id: 213,
							categoriapai_id: 19,
							descricao: 'Antisséptico bucal',
							nivel: 2,
							status: 1,
							integracao_id: '1262',
							codigo: '1262',
						},
						{
							id: 67,
							categoriapai_id: 19,
							descricao: 'Creme dental',
							nivel: 2,
							status: 1,
							integracao_id: '1263',
							codigo: '1263',
						},
						{
							id: 249,
							categoriapai_id: 19,
							descricao: 'Escova dental',
							nivel: 2,
							status: 1,
							integracao_id: '1264',
							codigo: '1264',
						},
						{
							id: 211,
							categoriapai_id: 19,
							descricao: 'Fio dental',
							nivel: 2,
							status: 1,
							integracao_id: '1265',
							codigo: '1265',
						},
						{
							id: 156,
							categoriapai_id: 19,
							descricao: 'Protetor de cerdas',
							nivel: 2,
							status: 1,
							integracao_id: '1284',
							codigo: '1284',
						},
					],
					codigo: '1078',
				},
				{
					id: 27,
					categoriapai_id: null,
					descricao: 'Higiene pessoal',
					nivel: 1,
					status: 1,
					integracao_id: '37',
					filhos: [
						{
							id: 192,
							categoriapai_id: 27,
							descricao: 'Absorvente',
							nivel: 2,
							status: 1,
							integracao_id: '1319',
							filhos: [
								{
									id: 381,
									categoriapai_id: 192,
									descricao: 'GERIATRICO',
									nivel: 3,
									status: 1,
									integracao_id: '1321',
								},
								{
									id: 798,
									categoriapai_id: 192,
									descricao: 'INTERNO',
									nivel: 3,
									status: 1,
									integracao_id: '1322',
								},
								{
									id: 621,
									categoriapai_id: 192,
									descricao: 'NORMAL',
									nivel: 3,
									status: 1,
									integracao_id: '1324',
								},
								{
									id: 799,
									categoriapai_id: 192,
									descricao: 'SEIOS',
									nivel: 3,
									status: 1,
									integracao_id: '1323',
								},
							],
							codigo: '1319',
						},
						{
							id: 214,
							categoriapai_id: 27,
							descricao: 'Haste flexivel',
							nivel: 2,
							status: 1,
							integracao_id: '235',
							filhos: [
								{
									id: 695,
									categoriapai_id: 214,
									descricao: 'HASTE FLEXIVEL',
									nivel: 3,
									status: 1,
									integracao_id: '345',
								},
							],
							codigo: '235',
						},
						{
							id: 321,
							categoriapai_id: 27,
							descricao: 'Sabonete',
							nivel: 2,
							status: 1,
							integracao_id: '44',
							filhos: [
								{
									id: 600,
									categoriapai_id: 321,
									descricao: 'BARRA',
									nivel: 3,
									status: 1,
									integracao_id: '47',
								},
								{
									id: 448,
									categoriapai_id: 321,
									descricao: 'ESTOJO',
									nivel: 3,
									status: 1,
									integracao_id: '1343',
								},
								{
									id: 389,
									categoriapai_id: 321,
									descricao: 'INTIMO',
									nivel: 3,
									status: 1,
									integracao_id: '1344',
								},
								{
									id: 572,
									categoriapai_id: 321,
									descricao: 'LÍQUIDO',
									nivel: 3,
									status: 1,
									integracao_id: '1342',
								},
							],
							codigo: '44',
						},
					],
					codigo: '37',
				},
				{
					id: 941,
					categoriapai_id: null,
					descricao: 'Limpeza',
					nivel: 1,
					status: 1,
					integracao_id: '1667',
					filhos: [
						{
							id: 945,
							categoriapai_id: 941,
							descricao: 'Desinfetante',
							nivel: 2,
							status: 1,
							integracao_id: '1670',
							codigo: '1670',
						},
						{
							id: 946,
							categoriapai_id: 941,
							descricao: 'Escova',
							nivel: 2,
							status: 1,
							integracao_id: '1671',
							codigo: '1671',
						},
						{
							id: 951,
							categoriapai_id: 941,
							descricao: 'Esfregão',
							nivel: 2,
							status: 1,
							integracao_id: '1691',
							codigo: '1691',
						},
						{
							id: 954,
							categoriapai_id: 941,
							descricao: 'Esponja',
							nivel: 2,
							status: 1,
							integracao_id: '1690',
							codigo: '1690',
						},
						{
							id: 952,
							categoriapai_id: 941,
							descricao: 'Pano',
							nivel: 2,
							status: 1,
							integracao_id: '1675',
							codigo: '1675',
						},
						{
							id: 955,
							categoriapai_id: 941,
							descricao: 'Rodo',
							nivel: 2,
							status: 1,
							integracao_id: '1676',
							codigo: '1676',
						},
						{
							id: 948,
							categoriapai_id: 941,
							descricao: 'Sabão',
							nivel: 2,
							status: 1,
							integracao_id: '1677',
							codigo: '1677',
						},
						{
							id: 949,
							categoriapai_id: 941,
							descricao: 'Vassoura',
							nivel: 2,
							status: 1,
							integracao_id: '1678',
							codigo: '1678',
						},
					],
					codigo: '1667',
				},
				{
					id: 24,
					categoriapai_id: null,
					descricao: 'Preservativo',
					nivel: 1,
					status: 1,
					integracao_id: '152',
					filhos: [
						{
							id: 71,
							categoriapai_id: 24,
							descricao: 'Lubrificante',
							nivel: 2,
							status: 1,
							integracao_id: '1299',
							codigo: '1299',
						},
						{
							id: 251,
							categoriapai_id: 24,
							descricao: 'Preservativo',
							nivel: 2,
							status: 1,
							integracao_id: '160',
							codigo: '160',
						},
					],
					codigo: '152',
				},
				{
					id: 10,
					categoriapai_id: null,
					descricao: 'Repelente',
					nivel: 1,
					status: 1,
					integracao_id: '348',
					filhos: [
						{
							id: 96,
							categoriapai_id: 10,
							descricao: 'Aparelho',
							nivel: 2,
							status: 1,
							integracao_id: '1254',
							codigo: '1254',
						},
						{
							id: 311,
							categoriapai_id: 10,
							descricao: 'Repelente',
							nivel: 2,
							status: 1,
							integracao_id: '349',
							codigo: '349',
						},
					],
					codigo: '348',
				},
			],
		};
	},
	computed: {
		settings() {
			return {
				infinite: true,
				speed: 800,
				slidesToShow: 6,
				slidesToScroll: 2,
				dots: false,
				autoplay: false,
				autoplaySpeed: 4000,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4,
						},
					},
					{
						breakpoint: 815,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4,
						},
					},
					{
						breakpoint: 630,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 365,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 275,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			};
		},
	},
	methods: {
		parseTitle(title) {
			// eslint-disable-next-line no-param-reassign
			title = title.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			// eslint-disable-next-line no-param-reassign
			title = title.toLowerCase();
			return title;
		},
	},
};
</script>
<style lang="scss">
.slider-categorias-destaque {
	.slick-next {
		right: -20px;
	}
	.slick-prev {
		left: -20px;
	}
}
</style>
<style lang="scss" scoped>
@import '~@/style/Global.css';
#section-categorias-destaque {
	max-width: 1360px;
	width: calc(100% - 20px);

	span {
		color: #303932;
	}
}

.desc-categoria {
	font-size: 14px;
	text-align: center;
}

:focus {
	outline: 0;
}
.border-green-custom {
	border-bottom-style: solid;
	border-bottom-color: var(--color-green-custom);
}
label {
	transition: all 0.3s ease-in-out;
}
.container-categoria {
	padding-top: 20px;
	transition: all 0.3s ease-in-out;
}
.container-categoria:hover {
	transform: scale(1.03);
}
.hover:hover label {
	color: var(--color-green-custom);
}
.slider-categorias-destaque {
	z-index: 0;
	.slick-next {
		right: -20px;
	}
}
.item-item img {
	width: 120px;
}
@media (max-width: 900px) {
	.item-item img {
		width: 100px;
	}
}
</style>

